import React, { useEffect, useState } from "react";
import SidebarLayout from "../../common/sidebar/SidebarLayout";
import { Helmet } from "react-helmet";
import PatientLoader from "../../common/PatientLoader";
import { useDispatch, useSelector } from "react-redux";
import { InfoCard } from "../dashboard/DashboardHome";
import {
  patientLogic,
  bhiPatientLogic,
} from "../../../store/features/patient/patientSlice";
import { useNavigate } from "react-router-dom";
import CardLayout from "../../common/cardLayout/CardLayout";
import BillingStatsChart from "./BillingStatsChart";
import moment from "moment";
import TabSwitcherComponent from "./TabSwitcherComponent";
import PatientEngagementMetrics from "./PatientEngagementMetrics";
import BehavioralHealthMetrics from "./BehavioralHealthMetrics";
import OPSPrimaryHeader from "../../common/primaryHeader/OPSPrimaryHeader";
import { getFullName } from "../../../util/helpers";

const ACOExecutiveDashboard = () => {
  const navigate = useNavigate();

  const [totalActivePatient, setTotalActivePatient] = useState(0);
  const dispatch = useDispatch();
  const { loading, user, staffData } = useSelector((state) => state.app);
  const { patientCount, patientData, inActivePatient, billableBHIPatients } =
    useSelector((state) => state.patient);

  const [currentTab, setCurrentTab] = useState(1);

  useEffect(() => {
    dispatch(
      patientLogic({
        page_size: 999999,
        page: 1,
        clinic_id: user?.clinic?.id,
        clinician_id: user?.id,
      })
    );

    dispatch(
      bhiPatientLogic({
        page_size: 999999,
        page: 1,
        clinic_id: user?.clinic?.id,
        clinician_id: user?.id,
        bhi_info__id__isnull: false,
        assessed: moment()
          .subtract(1, "months")
          .startOf("month")
          .format("YYYY-MM-DD"), //1st of current month - 1
        bhi_enrollment_date: moment().startOf("month").format("YYYY-MM-DD"), //1st of current month
      })
    );
    //setBhiBillingCount(billableBHIPatients.length);
  }, [user]);

  useEffect(() => {
    setTotalActivePatient(patientCount - inActivePatient?.length);
  }, [patientCount]);
  const handleNavigation = (navigate_to) => {
    navigate(navigate_to);
  };
  const getBHIEligibleCount = (patients) => {
    let count = 0;

    patients.forEach((x) => {
      if (x.bhi_eligible && !x.bhi_enabled) count = count + 1;
    });
    return count;
  };

  const getBHIEnrolledCount = (patients) => {
    let count = 0;

    patients.forEach((x) => {
      if (x.bhi_enabled) count = count + 1;
    });
    return count;
  };
  return (
    <SidebarLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>ACOExecutiveDashboard | Precise Digital</title>
        <link rel="canonical" href={window.location.origin} />
      </Helmet>
      {loading ? (
        <PatientLoader />
      ) : (
        <>
          <OPSPrimaryHeader
            titleText={`Hey ${
              getFullName(user) === "" ? "ACO Officer" : getFullName(user)
            },`}
            showSubtitle={false}
            showButton={false}
          />

          <div
            className="container-fluid px-4 py-2 row"
            style={{
              margin: "0px",
              display: "flex",
            }}
          >
            <div
              className="  col-sm-4 col-md-4 col-lg-4"
              style={{
                margin: "0px",
                padding: "0px",
                border: "5px solid transparent",
                boxSizing: "border-box",
                backgroundClip: "padding-box",
              }}
            >
              <InfoCard
                title={"Care Team"}
                button_link={"/aco/members/"}
                button_text={"Team Members"}
                stats={staffData?.length || 0}
                information={"View all Care Team Members"}
                show_link={true}
                handleNavigation={handleNavigation}
              />
            </div>

            <div
              className="col-sm-4 col-md-4 col-lg-4"
              style={{
                margin: "0px",
                padding: "0px",
                border: "5px solid transparent",
                boxSizing: "border-box",
                backgroundClip: "padding-box",
              }}
            >
              <InfoCard
                title={"Total Patient"}
                button_link={"/aco/patient/total/"}
                button_text={"Patients till Date"}
                stats={patientCount || 0}
                information={"View all Patients"}
                show_link={true}
                handleNavigation={handleNavigation}
              />
            </div>
            <div
              className="col-sm-4 col-md-4 col-lg-4"
              style={{
                margin: "0px",
                padding: "0px",
                border: "5px solid transparent",
                boxSizing: "border-box",
                backgroundClip: "padding-box",
              }}
            >
              <InfoCard
                title={"Active Patient"}
                button_link={"/aco/patient/active/"}
                button_text={" Active Patients on Rose"}
                stats={totalActivePatient || 0}
                information={"View active Patients in Rose Health"}
                show_link={true}
                handleNavigation={handleNavigation}
              />
            </div>
          </div>
          <TabSwitcherComponent
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
          />
          <div className="row mt-2 px-4">
            {currentTab === 1 && (
              <div className="row" style={{ margin: "0px", padding: "0px" }}>
                <div
                  className="container-fluid px-4 py-2 row"
                  style={{
                    margin: "0px",
                    display: "flex",
                  }}
                >
                  <CardLayout className="col-sm-12 col-md-12 col-lg-12">
                    <div className="row col-sm-12 col-md-12 col-lg-12 container-fluid px-1 py-2 row">
                      <h4 style={{ textAlign: "left", color: "#66D3FA" }}>
                        Billing Stats
                      </h4>
                    </div>
                    {loading ? (
                      <PatientLoader />
                    ) : (
                      <BillingStatsChart
                        bhiEligibleCount={getBHIEligibleCount(patientData)}
                        bhiEnrolledCount={getBHIEnrolledCount(patientData)}
                        bhiBillingCount={billableBHIPatients?.length}
                      />
                    )}
                  </CardLayout>
                </div>
              </div>
            )}
            {currentTab === 2 && (
              <div
                className="container-fluid"
                style={{ margin: "0px", padding: "0px" }}
              >
                <PatientEngagementMetrics
                  patientData={patientData}
                  user={user}
                />
              </div>
            )}
            {currentTab === 3 && (
              <div
                className="container-fluid"
                style={{ margin: "0px", padding: "0px" }}
              >
                <BehavioralHealthMetrics user={user} />
              </div>
            )}
          </div>
        </>
      )}
    </SidebarLayout>
  );
};

export default ACOExecutiveDashboard;
